import styled from 'styled-components';
import { ModalSheet } from '@/components/UI/ModalSheet';
import { Button } from '@/components/UI/Button/Button';

export const Sheet = styled(ModalSheet)`
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    svg {
      width: 20px;
      height: 20px;
    }
  }
`;

export const Cards = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-top: 10px;
`;

export const Actions = styled.div`
  padding: 30px 0 10px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 20px 0;
  }
`;

export const TopUpButton = styled(Button).attrs({
  appearance: 'secondary',
  isFullWidth: true,
  borderRadius: 14,
})``;
